/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-12 10:22:52
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import styles from './PEIManagement.module.css'
import {
  getPEIManagementDetailAsync,
  getPEIManagementSubmitAsync,
} from './PEIManagementSlice'
import {
  DateTimeFormat,
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
} from '../../../models/datetime'
import { getUserList } from '../../user/userSlice'
import { GenderOptions, getGenderName } from '../../../models/user'
const { Option } = Select

export const AddOrEditFormModal = (props: {
  editTenantId?: any
  isEdit?: any
  id?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [detail, setDetail] = useState<any>()

  const [userList, setUserList] = useState<any>()

  const [id, setId] = useState<any>()

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  const layouts = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  }
  const getDetail = () => {
    dispatch(
      getPEIManagementDetailAsync({
        id: props?.id,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        form.setFieldsValue({
          ...v,
          examDate: v?.examDate ? moment(v?.examDate) : '',
          employeeId: undefined,
          sex: undefined,
        })

        dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
          .then(unwrapResult)
          .then((res: any) => {
            setUserList(res?.items)

            const employeeId = res?.items?.find(
              (vs: any) => vs?.id == v?.employeeId
            )

            form.setFieldsValue({
              employeeId:
                employeeId != undefined ? v?.employeeId?.toString() : undefined,
              sex: employeeId != undefined ? Number(v?.sex) : undefined,
            })
          })
      })
  }

  const getUserData = () => {
    dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
      .then(unwrapResult)
      .then((res: any) => {
        setUserList(res?.items)
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      } else {
        getUserData()
      }
    } else {
      form.resetFields()
      setUserList([])
      setDetail({})
    }
  }, [props.isModalVisible, props?.id])

  return (
    <>
      <Modal
        width={800}
        title={
          props?.isEdit == '0'
            ? '查看详情'
            : props?.id
            ? '编辑数据'
            : '添加数据'
        }
        className={styles.formModal}
        visible={props.isModalVisible}
        footer={null}
        maskClosable={false}
        destroyOnClose={false}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(vs) => {
            const employeeName = userList?.find(
              (v: any) => v?.id == vs?.employeeId
            )?.name

            const examDate = vs?.examDate
              ? moment(vs?.examDate)?.format(DateTimeFormatSimple)
              : ''
            setConfirmLoading(true)
            const params = props?.id
              ? {
                  ...detail,
                  ...vs,
                  id: detail?.id,
                }
              : {
                  ...vs,
                }
            dispatch(
              getPEIManagementSubmitAsync({
                ...params,
                employeeName: employeeName,
                examDate: examDate,
              })
            )
              .then(unwrapResult)
              .then((v: any) => {
                notification.success({
                  message: '操作成功',
                })
              })
              .finally(() => {
                props?.onOk()
                setConfirmLoading(false)
              })
          }}
        >
          <Row>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='姓名'
                name='employeeId'
                rules={[
                  {
                    required: true,
                    message: '姓名不能为空',
                  },
                ]}
              >
                <Select
                  placeholder='姓名'
                  allowClear
                  onChange={(v) => {
                    const sex = userList?.find((val: any) => val?.id == v)?.sex
                    form.setFieldsValue({
                      sex: sex,
                    })
                  }}
                >
                  {userList?.map((v: any, i: any) => {
                    return (
                      <Option value={v?.id} key={i}>
                        {v?.name}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='性别'
                name='sex'
                rules={[
                  {
                    required: true,
                    message: '性别不能为空',
                  },
                ]}
              >
                <Select placeholder='请选择' allowClear disabled>
                  {GenderOptions.map((g) => (
                    <Option key={g} value={g}>
                      {getGenderName(g)}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='体检机构'
                name='examOrganization'
                rules={[
                  {
                    required: true,
                    message: '体检机构不能为空',
                  },
                ]}
              >
                <Input placeholder='体检机构' maxLength={50} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='体检内容'
                name='examContent'
                rules={[
                  {
                    required: true,
                    message: '体检内容不能为空',
                  },
                ]}
              >
                <Input placeholder='体检内容' maxLength={50} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...layout} label='体检结果' name='examResult'>
                <Input placeholder='体检结果' maxLength={200} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='体检日期'
                name='examDate'
                rules={[
                  {
                    required: true,
                    message: '体检日期不能为空',
                  },
                ]}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder='体检日期'
                  format={DateTimeFormatSimple}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item {...layouts} label='采取措施' name='measures'>
                <Input.TextArea
                  placeholder='采取措施'
                  showCount
                  rows={3}
                  maxLength={200}
                />
              </Form.Item>
            </Col>
          </Row>
          {props?.isEdit == '0' ? (
            <></>
          ) : (
            <Row
              style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                loading={confirmLoading}
                type='primary'
                onClick={() => {
                  form.submit()
                }}
                style={{ marginRight: '10px' }}
              >
                确定
              </Button>
              <Button
                type='primary'
                ghost
                style={{ marginRight: '10px' }}
                onClick={() => {
                  props?.onCancel()
                }}
              >
                取消
              </Button>
            </Row>
          )}
        </Form>
      </Modal>
    </>
  )
}
